module.exports = new __parcel__URL__("84043_sq.3d0fb0d3.jpg").toString();